import React from "react";

import { epocToDate, formatSecsToHrRange } from "utils";

function nextSchedule(props) {
  let content = "Next backup is scheduled between: ";
  let time = "";
  let currentTime = Math.round(new Date().getTime() / 1000);

  let nextDay = Math.round(new Date().setHours(23, 59, 59, 999) / 1000);
  let sameDay = Math.round(new Date().setHours(0, 0, 0, 0) / 1000);

  let display = true;
  const currentType =
    props.scheduleInfo.type && props.scheduleInfo.type.current != null
      ? props.scheduleInfo.type.current
      : props.scheduleInfo.type;

  switch (props.enums.ScheduleType.props[currentType].key) {
    case "INTERVAL":
      if (props.scheduleInfo.scheduleChanged || props.isBackupPlan)
        time = epocToDate(
          currentTime + props.scheduleInfo.interval.selected,
          "MMM d yyyy, hh:mm:ss"
        );
      else {
        const nextBackupTime =
          props.clients[props.clientDetails.clientUUID].nextBackupTime;
        if (nextBackupTime < currentTime) {
          display = false;
        } else {
          time = epocToDate(nextBackupTime, "MMM d yyyy, hh:mm:ss");
        }
      }
      break;
    case "DAILY":
      if (
        currentTime >
        sameDay +
          (props.scheduleInfo.startTime &&
          props.scheduleInfo.startTime.value !== undefined
            ? props.scheduleInfo.startTime.value
            : props.scheduleInfo.startTime)
      ) {
        time =
          epocToDate(
            nextDay +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d yyyy,"
          ) +
          " " +
          formatSecsToHrRange(
            props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
              ? props.scheduleInfo.startTime.value
              : props.scheduleInfo.startTime
          );
      } else {
        time =
          epocToDate(
            sameDay +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d yyyy"
          ) +
          " " +
          formatSecsToHrRange(
            props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
              ? props.scheduleInfo.startTime.value
              : props.scheduleInfo.startTime
          );
      }

      break;
    case "CUSTOM":
      let FinalDays = 8;
      let minDays;
      props.scheduleInfo.weekDays.forEach(v => {
        minDays = (7 + (v - new Date().getDay())) % 7;
        if (minDays < FinalDays) {
          if (minDays === 0) {
            if (
              currentTime >
              sameDay +
                (props.scheduleInfo.startTime &&
                props.scheduleInfo.startTime.value !== undefined
                  ? props.scheduleInfo.startTime.value
                  : props.scheduleInfo.startTime)
            ) {
              FinalDays = 7;
            } else {
              FinalDays = minDays;
            }
          } else {
            FinalDays = minDays;
          }
        }
      });

      if (FinalDays !== 8) {
        time =
          epocToDate(
            sameDay +
              FinalDays * 60 * 60 * 24 +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d yyyy"
          ) +
          " " +
          formatSecsToHrRange(
            props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
              ? props.scheduleInfo.startTime.value
              : props.scheduleInfo.startTime
          );
      }
      break;
    case "NO_SCHEDULE":
      content = "No Backup is scheduled";
      break;
    default:
      break;
  }

  return (
    <React.Fragment>
      {display ? (
        <div className="next_schedule_msg">
          <p>
            {content}
            <strong>{time}</strong>
          </p>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

export default nextSchedule;
